import { render, staticRenderFns } from "./ProtestedTaxFooter.vue?vue&type=template&id=cc34a8fe&scoped=true&"
import script from "./ProtestedTaxFooter.vue?vue&type=script&lang=js&"
export * from "./ProtestedTaxFooter.vue?vue&type=script&lang=js&"
import style0 from "./ProtestedTaxFooter.vue?vue&type=style&index=0&id=cc34a8fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc34a8fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCol,VContainer,VRow,VTextField,VTooltip})
